import React from 'react';
import PropTypes from 'prop-types';
import RCSlider, { Range as RCRange } from 'rc-slider';
import 'rc-slider/assets/index.css';
import './slider.scss';

const Slider = (props) => {
  return (
    <RCSlider {...props} />
  );
};

const Range = (props) => {
  return (
    <RCRange {...props} />
  );
};

const commonTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  onAfterChange: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

Slider.propTypes = {
  ...commonTypes,
  value: PropTypes.number.isRequired,
  ariaLabelForHandle: PropTypes.string,
};

Range.propTypes = {
  ...commonTypes,
  value: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  ariaLabelGroupForHandles: PropTypes.arrayOf(PropTypes.string),
  allowCross: PropTypes.bool,
};

export {
  Slider,
  Range,
};
